module.exports = __webpack_public_path__ + "img/35.746ebab4.jpg";